import { SPOTLIGHT_POSITION_GATE } from '../constants/gates';
import { ALIGNED_CENTER_CLASS, ALIGNED_LEFT_CLASS, ALIGNED_RIGHT_CLASS } from '../constants/widgetClassNames';
/**
 * Picks the alignment class for a Spotlight widget. The chatflow's
 * `spotlightConfig.position` only takes effect while the
 * `LiveChat:SpotlightPosition` gate is on; otherwise Spotlight stays centered.
 */
export const getSpotlightAlignmentClass = widgetData => {
  var _widgetData$gates, _widgetData$message;
  if ((widgetData === null || widgetData === void 0 || (_widgetData$gates = widgetData.gates) === null || _widgetData$gates === void 0 ? void 0 : _widgetData$gates[SPOTLIGHT_POSITION_GATE]) !== true) {
    return ALIGNED_CENTER_CLASS;
  }
  switch ((_widgetData$message = widgetData.message) === null || _widgetData$message === void 0 || (_widgetData$message = _widgetData$message.spotlightConfig) === null || _widgetData$message === void 0 ? void 0 : _widgetData$message.position) {
    case 'right':
      return ALIGNED_RIGHT_CLASS;
    case 'left':
      return ALIGNED_LEFT_CLASS;
    default:
      return ALIGNED_CENTER_CLASS;
  }
};